import React, {createRef} from 'react'
import NavigationStructure from "../../core/model2/navigation/navigation-structure"
import {LayoutMenuState} from "../layout/const"
import navigation_clickSectionWhenMenuStatic from "./actions/click-section-menu-static"
import navigation_clickSectionWhenMenuPopover from "./actions/click-section-menu-popover"
import ErrorBoundary from "../../core/error-boundary"
import NavigationSection from "../../core/model2/navigation/navigation-section"
import {
    BUS_LAYOUT_MENU_MIN_POPOVER_CHAGED,
    EVENT_BUS_LAYOUT_ON_HEIGHT_CHANGE,
    EVENT_BUS_LAYOUT_ON_WIDTH_CHANGE
} from "../layout/bus-events"
import navigation_autoHideToMoreVertical from "./actions/auto-hide/auto-hide-to-more-vertical"
import navigation_clickSectionWhenAppNoMenu from "./actions/click-section-app-no-menu"
import NavigationCustomer from "./customer";
import {EVENT_BUS_MENU_RERENDER} from "../menu/sections/const"
import {
    SESSION_COMPANY_CHANGE,
    SESSION_CUSTOM_VIEWS_CHANGE,
    SESSION_PROJECT_CHANGE,
    SESSION_PROJECT_DELETE,
    SESSION_PROJECT_NEW,
    SESSION_PROJECT_USERS_CHANGED,
} from "../../core/gd/bus/bus-event-type"
import ProjectSession from "../../core/model2/project/project-session";
import navigation_autoHideToMoreHorizontal from "./actions/auto-hide/auto-hide-to-more-horizontal"
import {UIType} from "../ui/@const";
import {BUS_MAIN_MENU_OUTSIDE_CLICK} from "./@const";

// const debug = "NavigationPanel"
const debug = false

type Props = {
}

type State = {
    currentSection? : NavigationSection
    navWidth        : number
}

export default class NavigationPanel extends React.Component<Props, State> {

    private navRef = createRef<HTMLDivElement>(); // Typed ref
    private resizeObserver: ResizeObserver | null = null; // Observer instance

    constructor(props:Props) {
        super(props);

        // Not sure why we need it... but ok
        this.navigationStructure.initSections()

        this.state = {
            currentSection  : undefined,
            navWidth        : 0
        }

        debug && console.log(debug, "constructor", this.state.currentSection)
    }

    get navigationStructure():NavigationStructure {
        return gd.navigationStructure
    }

    componentDidMount() {
        // console.green("didMount")

        // stupid ? each time ... whatever :)
        gd.layout.navigation = this

        gd.bus.subscribe(BUS_MAIN_MENU_OUTSIDE_CLICK,this, this.reRender);
        gd.bus.subscribe(BUS_LAYOUT_MENU_MIN_POPOVER_CHAGED,this, this.reRender.bind(this,"layout-menu-min-popover-changed"));
        gd.bus.subscribe(SESSION_COMPANY_CHANGE,this, this.reRender);
        gd.bus.subscribe(SESSION_CUSTOM_VIEWS_CHANGE, this, this.reset)
        gd.bus.subscribe(SESSION_PROJECT_CHANGE, this, this.updateWorkspace)
        gd.bus.subscribe(SESSION_PROJECT_NEW, this, this.onProjectAddDelete)
        gd.bus.subscribe(SESSION_PROJECT_DELETE, this, this.onProjectAddDelete)
        gd.bus.subscribe(SESSION_PROJECT_USERS_CHANGED, this, this.onProjectUsersChanged)

        if (gd.ui.type === UIType.TOP) {
            gd.bus.subscribe(EVENT_BUS_LAYOUT_ON_WIDTH_CHANGE, this, this.onWindowResize)
        } else {
            gd.bus.subscribe(EVENT_BUS_LAYOUT_ON_HEIGHT_CHANGE, this, this.onWindowResize)
        }

        gd.modelBus.subscribe('company-user.{0}-{1}'.f(gd.companyId, gd.user.id), this, this.onCompanyUserUpdate)

        if (this.navRef.current) {
            this.resizeObserver = new ResizeObserver((entries) => {
                const newWidth = entries[0].contentRect.width;
                this.setState({ navWidth: newWidth });
            });

            this.resizeObserver.observe(this.navRef.current);
        }

        this.reRender()
    }

    autoHideToMore() {

        if (gd.ui.type === UIType.TOP) {
            navigation_autoHideToMoreHorizontal()
        } else {
            navigation_autoHideToMoreVertical()
        }
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);

        if (this.resizeObserver) {
            this.resizeObserver.disconnect(); // Cleanup observer
        }
    }

    async initAndRenderDefaultSection() {
        await this.setCurrentSection(this.navigationStructure.defaultSectionWithMenu)
        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    onWindowResize() {
        this.reRender()
    }

    onCompanyUserUpdate = (method: string, data: any) => {
        debug && console.log(debug, "onCompanyUserUpdate", data.hasOwnProperty('clockInOutEnabled'), data)

        if (data.hasOwnProperty('clockInOutEnabled')) {
            this.reset()
            this.reRender()
        }
    }

    reset() {
        // console.brown("Navigation reset")
        this.navigationStructure.initSections()
    }

    updateWorkspace = (projectId: ID) => {
        const workspace = gd.spaces.workspaces.getByProjectId(projectId)
        debug && console.log(debug, "updateWorkspace", workspace)
        if (workspace) {
            this.navigationStructure.initSections()
            this.reRender()
        }
    }

    onProjectAddDelete = (project: ProjectSession) => {
        debug && console.log(debug, "onProjectAddDelete", project)

        if (project.isWorkspace) {
            this.reRender()
        }
    }

    onProjectUsersChanged = () => {
        debug && console.log(debug, "onProjectUsersChanged")

        this.reRender()
    }

    async openSectionV2(section:NavigationSection):Promise<any> {

        if (!section) {
            throw new Error("#048dd472 no section passed")
        }

        debug && console.log(debug, "openSectionV2", section.id, "isMenuHiddenForCurrentApp", gd.layout.isMenuHiddenForCurrentApp)

        return new Promise(async (resolve, reject) => {

            if (gd.layout.isMenuHiddenForCurrentApp) {
                await navigation_clickSectionWhenAppNoMenu(this, section, resolve, reject)
                // navigation_clickSectionWhenMenuPopover(this, section, resolve, reject)
                return
            }

            if (gd.layout.menuState === LayoutMenuState.STATIC) {
                navigation_clickSectionWhenMenuStatic(this, section, resolve, reject)
                return
            } else {
                await navigation_clickSectionWhenMenuPopover(this, section, resolve, reject)
                this.reRender()
                return
            }
        })
    }

    // this is perryt much a copy of openSectionV2 but it does not open menu if it's hidden (minimized or small screen)
    async openSectionOnAppStart(section:NavigationSection):Promise<any> {

        debug && console.log(debug, "openSectionOnAppStart", section.id, "isMenuHiddenForCurrentApp", gd.layout.isMenuHiddenForCurrentApp, gd.layout.menuState)

        return new Promise(async (resolve, reject) => {

            if (gd.layout.isMenuHiddenForCurrentApp) {
                await navigation_clickSectionWhenMenuPopover(this, section, resolve, reject)
                return
            }

            if (gd.layout.menuState === LayoutMenuState.STATIC) {
                await navigation_clickSectionWhenMenuStatic(this, section, resolve, reject)
                return
            } else {
                // do nothing
                // await navigation_clickSectionWhenMenuPopover(this, section, resolve, reject)
                resolve(true)
                return
            }
        })
    }

    // update currentSection and re-render
    async setCurrentSection(section:NavigationSection) {
        return new Promise((resolve, reject) => {
            this.setState({
                currentSection     : section
            },async ()=>{
                debug && console.log(debug, "setCurrentSection", this.state.currentSection)
                resolve(true)
            })
        })
    }

    onDragNavigationSectionsEnd = (index: number, navigationSections: any[]) => {
        debug && console.log(debug, "onDragNavigationSectionsEnd", index, navigationSections)
    }

    reRender(calledBy:string='unknown') {
        this.autoHideToMore()
        this.forceUpdate()
    }

    render() {

        debug && console.blue(debug, "render", this.state.currentSection?.id)

        gd.layout.navigation = this // stranno na did mount ne hochet srabativat' pishet error


        const navigationClasses = Classes(gd.ui.navigationPanelMainClass, {
            'is-menu-opened': gd.layout.isStaticMenu || gd.layout.isMenuPopoverShown
        });

        return (
            <div ref={this.navRef} className={navigationClasses}>
                <ErrorBoundary>
                    {gd.user.acl.isClient &&
                        <NavigationCustomer navigationStructure         = {this.navigationStructure}
                                            onDragNavigationSectionsEnd = {this.onDragNavigationSectionsEnd} />
                    }

                    {!gd.user.acl.isClient &&
                        <gd.ui.NavigationPanelUserComponent navWidth                    = {this.state.navWidth}
                                                            navigationStructure         = {this.navigationStructure}
                                                            onDragNavigationSectionsEnd = {this.onDragNavigationSectionsEnd} />
                    }
                </ErrorBoundary>
            </div>
        )
    }



}
